module.exports = __webpack_public_path__ + "static/media/the-paraguay-reader-nickson-lambert.1c16dee4.jpg";